ui-cms-text-infobox {
  display: block;

  .text-infobox {
    display: flex;
    flex-direction: column-reverse;

    &--richtext {
      margin-top: $sd-spacing-4;
      display: block;
    }

    ui-cms-container {
      margin-top: $sd-spacing-3;
      position: relative;
    }

    .text-infobox__text-Wrapper__container {
      display: flex;
      flex-direction: column;

      figure {
        margin: 0;
      }

      &--reverse {
        flex-direction: column-reverse;
      }

      &--img {
        margin-top: $sd-spacing-5;
        margin-bottom: $sd-spacing-2;

        &-caption {
          margin-top: $sd-spacing-2;
        }
      }
    }
  }

  @include breakpoint($small) {
    .text-infobox {
      margin-top: -7px;

      &--float-right,
      &--float-left {
        .text-infobox__text-wrapper {
          display: flex;
          flex-flow: row wrap;
        }
      }

      &--float-right {
        display: block;

        ui-cms-container {
          margin-top: $sd-spacing-2;
          margin-bottom: $sd-spacing-2;
          margin-left: $sd-spacing-8;
          width: 47.6563%;
          float: right;
        }
      }

      &--float-left {
        display: block;

        ui-cms-container {
          margin-top: $sd-spacing-2;
          margin-bottom: $sd-spacing-2;
          margin-right: $sd-spacing-8;
          width: 47.6563%;
          float: left;
        }
      }
    }
  }

  @include breakpoint($medium) {
    .text-infobox {
      &--float-right {
        ui-cms-container {
          margin-right: -26.1719%;
          /* stylelint-disable-next-line function-no-unknown */
          margin-left: 3 * gutter();
        }
      }

      &--float-left {
        ui-cms-container {
          margin-left: -26.1719%;
          /* stylelint-disable-next-line function-no-unknown */
          margin-right: 3 * gutter();
        }
      }
    }
  }
}
